import '@/assets/main.scss'
import '@/plugins/router'
import '@/plugins/vant'
import '@/plugins/focus'
import '@/plugins/screenAdaptation'
import Vue from 'vue'
import Router from 'vue-router'
import sensors from '@/plugins/sensors'
import Page from '@/components/freestyle/index.vue'
import store from '@/store'
import App from './App.vue'

Vue.use(sensors)
Vue.config.productionTip = false

const router = new Router({
  mode: 'history',
  base: '/landing',
  routes: [
    {
      path: '/',
      component: Page,
      name: 'home'
    },
    {
      path: '/:id',
      component: Page,
      name: 'page'
    }
  ]
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
